document.addEventListener('DOMContentLoaded', function() {
    const fileRegistry = new Map(); // Хранит fileId → {inputName, file}

    // Генерация ID файла
    const getFileId = async (file) => {
        const slice = file.slice(0, 102400); // Первые 100KB
        const buffer = await slice.arrayBuffer();
        const hash = await crypto.subtle.digest('SHA-256', buffer);
        return Array.from(new Uint8Array(hash)).map(b => b.toString(16).padStart(2, '0')).join('');
    };

    // Создание превью
    const createPreview = (file, container) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const preview = document.createElement('div');
            preview.className = 'file-upload__preview';
            preview.dataset.fileName = file.name;
            preview.innerHTML = `
                <div class="file-upload__preview__image-wrapper">
                    <img src="${e.target.result}" alt="${file.name}" class="file-upload__preview__image">
                    <button class="file-upload__preview__remove">×</button>
                </div>
                <span class="file-upload__preview__name">${file.name}</span>
            `;
            container.appendChild(preview);
        };
        reader.readAsDataURL(file);
    };

    // Обработчик загрузки файлов
    document.querySelectorAll('.file-upload input[type="file"]').forEach(input => {
        input.addEventListener('change', async function() {
            const container = this.closest('.file-upload').querySelector('.file-upload__previews');

            for (const file of Array.from(this.files)) {
                const fileId = await getFileId(file);

                if (fileRegistry.has(fileId)) {
                    alert('Этот файл уже был загружен!');
                    continue;
                }

                createPreview(file, container);
                fileRegistry.set(fileId, {
                    inputName: this.name,
                    file: file
                });
            }

            // Создаем новый DataTransfer и обновляем files
            const dt = new DataTransfer();
            Array.from(fileRegistry.values())
                .filter(item => item.inputName === this.name)
                .forEach(item => dt.items.add(item.file));

            this.files = dt.files;
        });
    });

    // Удаление файла
    document.addEventListener('click', function(e) {
        if (!e.target.classList.contains('file-upload__preview__remove')) return;

        const preview = e.target.closest('.file-upload__preview');
        const fileName = preview.dataset.fileName;
        const fileUpload = preview.closest('.file-upload');
        const input = fileUpload.querySelector('input[type="file"]');

        // Удаляем из registry
        for (const [id, data] of fileRegistry.entries()) {
            if (data.file.name === fileName && data.inputName === input.name) {
                fileRegistry.delete(id);
                break;
            }
        }

        // Обновляем files
        const dt = new DataTransfer();
        Array.from(input.files)
            .filter(file => file.name !== fileName)
            .forEach(file => dt.items.add(file));

        input.files = dt.files;
        preview.remove();
    });

    // Проверка перед отправкой
    /*document.getElementById('work_execution').addEventListener('submit', function(e) {
        const detailedFiles = document.querySelector('input[name="detailed_images[]"]').files;
        const commonFiles = document.querySelector('input[name="common_images[]"]').files;

        if (detailedFiles.length === 0) {
            alert('Пожалуйста, загрузите детальные фото');
            e.preventDefault();
            return;
        }

        if (commonFiles.length === 0) {
            alert('Пожалуйста, загрузите фото общего плана');
            e.preventDefault();
            return;
        }
    });*/
});